'use es6';

import { USERS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchUsersSearchPage, createGetUsersByIds, fetchUsersSearchPage, getUsersByIds } from 'reference-resolvers/api/UsersAPI';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
export const createUserGenericPageReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: USERS,
  createFetchSearchPage: createFetchUsersSearchPage,
  createFetchByIds: createGetUsersByIds,
  fetchByIds: getUsersByIds,
  fetchSearchPage: fetchUsersSearchPage
}, options));
export default (fetchSearchPage => createUserGenericPageReferenceResolver({
  fetchSearchPage
}));